import { useCallback, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft, CheckCircle2, Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SigningFlow } from "@/components/SigningFlow";
import { api, errMsg, loadTemplate, openPdf } from "@/lib/api";

export default function SignInPerson() {
  const { id } = useParams();
  const [c, setC] = useState(null);
  const [tpl, setTpl] = useState(null);

  const reload = useCallback(async () => {
    const r = await api.get(`/contracts/${id}`);
    setC(r.data);
  }, [id]);

  useEffect(() => {
    loadTemplate().then(setTpl);
    reload().catch((e) => toast.error(errMsg(e)));
  }, [reload]);

  if (!c || !tpl) return <div className="text-sm text-[#7B929C]">Caricamento…</div>;

  const sign = async (body) => {
    await api.post(`/contracts/${id}/signatures`, body);
    await reload();
  };

  return (
    <div className="space-y-6 fade-up">
      <div>
        <Link to={`/contratti/${id}`} className="text-xs text-[#7B929C] inline-flex items-center gap-1 hover:text-[#0B6E8F]" data-testid="back-to-contract"><ArrowLeft size={13} /> Torna al contratto</Link>
        <h1 className="font-serif-it text-4xl sm:text-5xl font-semibold mt-2">Firma in presenza</h1>
        <p className="text-sm text-[#47606B] mt-1">{c.number} • {c.data?.cliente_nome}. Ogni foglio va letto e firmato singolarmente dal Gestore e da ciascun committente{c.data?.cliente2_nome ? ` (${c.data.cliente_nome} e ${c.data.cliente2_nome})` : ""}.</p>
      </div>
      {c.pending.length === 0 ? (
        <div className="rounded-xl border border-[#BBF7D0] bg-[#F0FDF4] p-8 space-y-4" data-testid="signing-complete">
          <div className="flex items-center gap-2 text-[#166534] font-serif-it text-3xl font-semibold"><CheckCircle2 /> Tutti i fogli sono firmati</div>
          {c.final_pdf_path && <Button className="rounded-full" onClick={() => openPdf(`/contracts/${id}/final-pdf`)} data-testid="signing-final-pdf"><Download size={15} className="mr-2" /> Scarica contratto firmato</Button>}
        </div>
      ) : (
        <SigningFlow pending={c.pending} signatures={c.signatures || []} data={c.data || {}} extras={c.extras || []} template={tpl} onSign={sign} />
      )}
    </div>
  );
}
